import React,{useState} from 'react';
import { Route, Redirect } from "react-router-dom";
import Layout from '../containers/Layout/Layout';

type AppProps = {
  isLoggedIn: boolean;
  path: string;
  exact: boolean;
  component: any;
  key: string;
  isPrivate: boolean;
  name: string;
  toggle:boolean;
  setToggle: any;
  handleToggle: () => void;
}

const PrivateRoutes = ({ component: Component,toggle,setToggle,handleToggle, isLoggedIn, ...rest }: AppProps) => {
 
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Layout name={rest.name} toggle={toggle} setToggle={setToggle} handleToggle={handleToggle}>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect from={props.match.path} to="/login" exact />
        )
      }
    />
  )
}

export default PrivateRoutes;